/* Feedogo: ask for the feeder light as soon as the selected station changes.
   The page itself only asks on load and every 60s, so switching houses left the light off for up to a minute.
   This only calls the page's own fgEnsureLight(); it adds no new endpoint and does not touch the player. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var last = '';
  setInterval(function () {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow;
      if (!w || typeof w.fgEnsureLight !== 'function') return;
      var code = String(w.__liveKey || '').split('|')[0];
      if (code && code !== last) { last = code; w.fgEnsureLight(); }
    } catch (e) {}
  }, 500);
})();